export const getAuditRecordParentName = (type, doBolding = false) => {
    switch (type) {
        case "USER_LOGIN":
            return "Usuarios";
        case "USER_PERMISSIONS_CHANGED":
            return "Permisos";
        case "USER_CREATED":
            return "Usuarios";
        case "JSON_CONFIG_UPDATED":
            return "Descargas";
        case "JSON_REVERSE_DEFAULT":
            return "Descargas";
        case "SCRATCH_EXECUTED":
            return "Descargas";
        case "SCRATCH_CANCELLED":
            return "Descargas";
        case "FILE_DOWNLOADED":
            return "Descargas";
        case "DOWNLOAD_PROGRAMMING":
            return "Descargas";
        case "PASSWORD_CHANGE":
            return "Usuarios";
        case "EQUIVALENCES_UPDATE":
            return "Descargas";
        default:
            return type;
    }
}

export const getTranslatedAuditRecordType = (type) => {
    switch (type) {
        case "USER_LOGIN":
            return "inicios de sesión";
        case "USER_PERMISSIONS_CHANGED":
            return "cambios de permisos";
        case "USER_CREATED":
            return "creación de usuarios";
        case "JSON_CONFIG_UPDATED":
            return "parametrización de descargas";
        case "SCRATCH_EXECUTED":
            return "ejecución de descargas";
        case "SCRATCH_RETRYED":
            return "cancelación de descargas";
        case "SCRATCH_CANCELLED":
            return "cancelación de descargas";
        case "FILE_DOWNLOADED":
            return "descarga de ficheros";
        case "DOWNLOAD_PROGRAMMING":
            return "programación de descargas";
        case "PASSWORD_CHANGE":
            return "cambios de contraseña";
        case "EQUIVALENCES_UPDATE":
            return "actualización de equivalencias";
        default:
            return type;
    }
}